import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Paper } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { Login, LoginBg } from '../../components';
import { i18n } from '../../language';
import logoImg from '../../static/images/web_login_logo.png';
import { defauleSkipUrlRole } from '../../utils/check';
import { envFunc } from '../../utils/environments';

const useStyles = makeStyles((theme) => ({
  oval: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '5rem',
    height: '5rem',
    borderRadius: '50% !important',
    boxShadow: '0 5px 10px 0 rgba(0, 0, 0, 0.04)',
    position: 'absolute',
    top: '0',
    left: '50%',
    transform: 'translate(-50%, 0)',
  },
  logo: {
    fontFamily: 'NotoSans-Bold',
    color: '#001d63',
    fontSize: '0.875rem',
    fontWeight: 'bold',
  },
}));

export default function PageLogin({ history }) {
  const classes = useStyles();
  const loginInfo = useSelector((state) => state.loginInfo);
  const userRole = useSelector((state) => state.userRole);
  const wardInfo = useSelector((state) => state.wardInfo);
  const rouList = useSelector((state) => state.rouList);
  const [envLabel, setEnvLabel] = useState('');

  useEffect(() => {
    if (wardInfo.flag || loginInfo.flag) {
      history.replace(defauleSkipUrlRole(userRole, loginInfo.hospitalId, loginInfo.wardId, history.location.pathname));
    }
  }, [rouList]);

  useEffect(() => {
    (async () => {
      setEnvLabel(await envFunc.getEnvLabel());
    })();
  }, []);

  const title = () => {
    return (
      <>
        <span>{i18n.t('LOGIN_PAGE_TITLE')} </span>
        {envLabel ?? null ? <span style={{ color: 'red' }}>{`(${envLabel})`}</span> : <span />}
      </>
    );
  };
  return (
    <LoginBg title={title()} subTitle={i18n.t('LOGIN_ENTER_YOUR_INFORMATION_TO_LOGIN')}>
      <div style={{ position: 'relative' }}>
        <Login button={i18n.t('LOGIN_CONTINUE')} />
        <Paper className={classes.oval} elevation={3}>
          <img src={logoImg} alt="" className={classes.oval} />
          {/* <Typography className={classes.logo}>{i18n.t('LOGIN_LOGO')}</Typography> */}
        </Paper>
      </div>
    </LoginBg>
  );
}
